import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import messages from './messages';
import NavigationLink from '../NavigationLink';
import PostsIcon from '../../assets/svgs/sidebar/post.svg';

export default function JudgeSidebarItems() {
  const competition = useSelector((state) => state.competition);

  useEffect(() => {
    // dispatch(fetchCompetitions());
  }, []);
  // useEffect(() => {
  //     console.log(competition);
  //     // if (!init && competition && competition.current) {
  //     //
  //     //     SetInit(true);
  //     //     history.push(`/posts/${competition.current._id}/architecture`);
  //     // }
  // }, [competition]);

  return (
    <>
      <ul className="pl-0 text-left mt-5 side-link bo_bottom">
        <p>{messages.candidate}</p>
        {competition &&
          competition.list &&
          competition.list
            .sort((a, b) => parseFloat(a.title) > parseFloat(b.title))
            .reverse()
            .filter((c) => c.title <= competition.current.title)
            .map((c) => (
              <React.Fragment key={c._id}>
                <li className="">
                  <NavigationLink
                    to={`/posts/${c.title}/architectures`}
                    className="d-flex"
                  >
                    <span>
                      {' '}
                      <img src={PostsIcon} alt="" />{' '}
                    </span>
                    {c.title}
                    <b className="ml-auto mr-0">›</b>
                  </NavigationLink>
                </li>
              </React.Fragment>
            ))}
      </ul>
    </>
  );
}
